module.exports = __webpack_public_path__ + "img/warning.8e61a236.svg";